import { reflectKeys } from "@utils/key.reflactor";

export const SYNC_ONLINE_INTERVAL_MS = 30000;
export const HEART_BEAT_VALIDITY_DURATION_MS = 60000;
export const SYNC_TYPING_INTERVAL_MS = 3000;
export const TYPING_RESET_DURATION_MS = 5000;
export const DEFAULT_CONVO_DURATION_MS = 5184000 * 1000; // 60 days
export const SYNC_ONLINE_COUNT_INTERVAL_MS = 60000;
export const ENDPOINT_REGION = "ap-southeast-1";
export const SYSTEM_ADMIN_USER_ID = 1;
export const DEFAULT_WARNING_TIMER = 300;
export const LA_SPEECH_WARNING_TIMER = 180;
export const MESSAGE_CLIENT_CONNECTION_EVENT_TYPE = {
  MQTT_CLIENT_CREATED: "MQTT_CLIENT_CREATED",
  MQTT_CLIENT_CREATION_ERROR: "MQTT_CLIENT_CREATION_ERROR",
  MQTT_CLIENT_START_REQUESTED: "MQTT_CLIENT_START_REQUESTED",
  MESSAGE_CLIENT_CREATED: "MESSAGE_CLIENT_CREATED",
  NETWORK_ONLINE: "NETWORK_ONLINE",
  NETWORK_OFFLINE: "NETWORK_OFFLINE",
  NEW_CONNECTION: "NEW_CONNECTION",
  RECONNECTING: "RECONNECTING",
  CONNECTION_FAILURE: "CONNECTION_FAILURE",
  CONNECTION_SUCCESS: "CONNECTION_SUCCESS",
  DISCONNECTION: "DISCONNECTION",
  ERROR: "ERROR",
  STOPPED: "STOPPED",
  TERMINATED: "TERMINATED",
} as const;

export const USER_ACTIVITY_TRACK_IOT_EVENT_TYPE = {
  MQTT_CLIENT_CREATED: "iot-mqtt-client-created",
  MQTT_CLIENT_CREATION_ERROR: "iot-mqtt-client-creation-error",
  MQTT_CLIENT_START_REQUESTED: "iot-mqtt-client-start-requested",
  MESSAGE_CLIENT_CREATED: "iot-message-client-created",
  NETWORK_ONLINE: "iot-network-online",
  NETWORK_OFFLINE: "iot-network-offline",
  NEW_CONNECTION: "iot-new-connection",
  RECONNECTING: "iot-reconnecting",
  CONNECTION_FAILURE: "iot-connection-failure",
  CONNECTION_SUCCESS: "iot-connection-success",
  DISCONNECTION: "iot-disconnection",
  ERROR: "iot-error",
  STOPPED: "iot-stopped",
  TERMINATED: "iot-terminated",
} as const;

export const ONLINE_STATE = {
  OFFLINE: "OFFLINE",
  ONLINE: "ONLINE",
} as const;

export const TYPING_STATE = {
  STOP_TYPING: "STOP_TYPING",
  TYPING: "TYPING",
} as const;

export const EVENT_TOPIC_EVENT = {
  TERMINATED: "TERMINATED",
} as const;

export const CONVERSATION_TYPE = {
  LIVE_CHAT: "LIVE_CHAT",
  LEARNING_ASSISTANT: "LEARNING_ASSISTANT",
  TEXT_QUERY: "TEXT_QUERY",
} as const;

export const CONVERSATION_CHAT_REQUEST_STATUS = reflectKeys(["REQUESTED", "COMPLETE", "ERROR"]);

export const CONVERSATION_ROLE = {
  USER: "user",
  AI: "ai",
} as const;

export type ConversationRole = (typeof CONVERSATION_ROLE)[keyof typeof CONVERSATION_ROLE];

export const REALTIME_ERROR_TYPE = {
  REALTIME_EVENT_ERROR: "REALTIME_EVENT_ERROR",
  PARTIAL_SAVE_ERROR: "PARTIAL_SAVE_ERROR",
  LLM_FAILED_STATUS: "LLM_FAILED_STATUS",
  SESSION_CLOSED: "SESSION_CLOSED",
  APP_DISABLED: "APP_DISABLED",
  MIC_PERMISSION_DENIED: "MIC_PERMISSION_DENIED",
  MIC_NOT_FOUND: "MIC_NOT_FOUND",
} as const;

export const CONVERSATION_ACTION = {
  ASK_SALIS: "ASK_SALIS",
};
